import React from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  Card,
  CardBody,
  Button,
  Progress,
} from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import SearchPanel from "./search-panel";
import { store, authHeader, appHelpers } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import { connect } from "react-redux";
import PageEmptyContent from "../utils/page.empty-content";
import ResultList from "./result-list";
import { apiActions, alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { alertConstants, appConstants } from "../../_constants";
const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">Ticket Search</h1>
      <p className="mb-0 subtitle text-nowrap">Passenger details</p>
    </header>
  </div>
);

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class TicketSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeUser: null,
      flightDate: new Date(),
      ticketNumber: "",
      records: null,
      contentErrorText: false,
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      hasSearched: false,
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      //modal

      passengerDetails: false,
      pageSize: 10,
      currentPage: 1,
      totalFlightCounts: 1,
      manifestInfo: false,
      clickBD: false,
      manifestLink: "#",
      airlineSelectNotification: null,
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //    Fetch Airlines
    const reduxState = store.getState();
    // this.search();
  }

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  handleTicketNumberChange = (ticketNumber) => {
    this.setState({
      ticketNumber,
      contentErrorText: ticketNumber ? "" : this.state.contentErrorText,
    });
  };
  handleFlightDateChange = (flightDate) => {
    this.setState({ flightDate });
  };

  search = async () => {
    const { dispatch } = this.props;
    const { flightDate, ticketNumber } = this.state;
    if (!ticketNumber) {
      this.setState({ contentErrorText: "Ticket number is required!" });
      return;
    }
    this.setState({ contentError: false, hasSearched: true });

    const payload = {
      FlightDate: moment(flightDate).format("YYYY-MM-DD"),
      TicketNumber: ticketNumber,
    };
    dispatch(apiActions.startRequest());
    commonService
      .fetchTicketInfo(payload)
      .then((res) => {
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            records: response.data,
          });
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(
            alertActions.error(
              appHelpers.interpretErrorResponseAlt2(res.response)
            )
          );
          dispatch(apiActions.endRequest());
        }
      })
      .catch((err) => {
        dispatch(
          alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
        );
        dispatch(apiActions.endRequest());
      });
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  render() {
    let modalResponse = this.renderPageResponse();
    const {
      flightDate,
      ticketNumber,
      contentError,
      records,
      contentErrorText,
    } = this.state;
    const { requesting, pageRequesting, desAirports } = this.props;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
        <Card className="mb-4">
  {/* Progress bar for Pending API Request */}
  {(pageRequesting || requesting) && !pageRequesting && (
    <Progress
      striped
      animated
      color="success"
      value={100}
      className="mb-2"
    />
  )}

  <CardBody>
    <h6 className="mb-0 text-uppercase pull-left">Search By Ticket</h6>

    <div className="clearfix">&nbsp;</div>
    
    {/* Search Panel should always be visible */}
    <SearchPanel
      onSearch={this.search}
      flightDate={flightDate}
      flightDateChange={this.handleFlightDateChange}
      ticketNumber={ticketNumber}
      ticketNumberChange={this.handleTicketNumberChange}
      contentErrorText={contentErrorText}
    />

    <hr />

    {/* Show Loading Indicator Instead of Results when pageRequesting is true */}
    {requesting ? (
      <div style={{
        textAlign: "center",
        fontSize: "18px",
        fontWeight: "bold",
        padding: "50px"
      }}>
        ...loading
      </div>
    ) : contentError ? (
      <PageError error={this.state.contentError} />
    ) : (
      <CardBody>
        {records && Object.keys(records).length > 0 ? (
          <ResultList
            passengerName={records.PassengerName}
            flightDate={moment(records.FlightDate).format("YYYY-MM-DD")}
            flightNumber={records.FlightNumber}
            paxType={records.PassengerType}
            airlineCode={records.AirlineCode}
            airlineName={records.AirlineName}
            route={records.Route}
            ticketNumber={records.TicketNumber}
            basicFare={records.BasicFare}
            totalFare={records.TotalFare}
            tscCharge={records.TSCCharge}
            securityTax={records.SecurityTax}
            fuelSubcharge={records.FuelSurcharge}
            airportTax={records.AirportTax}
            currency={records.OriginalCurrency}
            amount={records.OriginalAmount}
          />
        ) : (
            <PageEmptyContent 
            message={
              this.state.hasSearched
                ? "No records match your search!"  
                : "No data yet. Start by selecting a flight date and entering your ticket number" 
            } 
            
            />
        )}
      </CardBody>
    )}
  </CardBody>

  <NotificationSystem ref="notificationSystem" />
</Card>

        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    airlinesCarriers: state.airlinesCarriers,
    desAirports: state.desAirports,
    depAirports: state.depAirports,
    requesting: state.api.requesting,
    pageRequesting: state.api.pageRequesting,
    modal: state.modal,
  };
}

export default connect(mapStateToProps)(TicketSearch);



// WEBPACK FOOTER //
// ./src/views/ticket-search/index.js